<template>
  <el-drawer direction="rtl" :visible="openView" :before-close="onCloseView"
             :show-close="false" size="500px" :with-header="false">
    <div style="padding: 20px;">
      <div class="drawer-header">
        <span class="drawer-title">{{ studentName }} 的家长</span>
        <el-button icon="el-icon-close" circle size="small" @click="onCloseView"></el-button>
      </div>
      <el-divider style="margin: 12px 0 20px;"></el-divider>

      <!-- 空状态 -->
      <div v-if="!loading && parents.length === 0" style="text-align:center;padding:60px 0;color:#999;">
        <i class="el-icon-user" style="font-size:48px;display:block;margin-bottom:12px;"></i>
        暂未绑定家长
      </div>

      <!-- 加载中 -->
      <div v-if="loading" style="text-align:center;padding:60px 0;">
        <i class="el-icon-loading" style="font-size:24px;"></i>
        <p>加载中...</p>
      </div>

      <!-- 家长卡片列表 -->
      <div v-if="!loading && parents.length > 0">
        <div v-for="(p, idx) in parents" :key="p.id"
             class="parent-card" :style="{ animationDelay: (idx * 0.08) + 's' }">
          <div class="card-avatar">
            {{ p.nickname ? p.nickname.charAt(0) : '?' }}
          </div>
          <div class="card-info">
            <div class="card-name">{{ p.nickname || '未设置昵称' }}</div>
            <div class="card-meta">
              <span v-if="p.phone"><i class="el-icon-phone"></i> {{ p.phone }}</span>
              <span v-if="p.wxOpenid" style="margin-left:12px;">
                <i class="el-icon-chat-dot-round" style="color:#07C160;"></i> 已授权微信
              </span>
            </div>
            <div class="card-time" v-if="p.createTime">
              注册时间：{{ p.createTime }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import { reqGetStudentParents } from '@/api/system/users'

export default {
  name: 'ParentDrawer',
  data () {
    return {
      openView: false,
      loading: false,
      studentName: '',
      parents: []
    }
  },
  methods: {
    async handleView (row) {
      this.openView = true
      this.loading = true
      this.studentName = row.nickname || '学生'
      this.parents = []
      try {
        const data = await reqGetStudentParents({ studentId: row.id })
        this.parents = data || []
      } catch (e) {
        this.parents = []
      } finally {
        this.loading = false
      }
    },
    onCloseView () {
      this.openView = false
    }
  }
}
</script>

<style lang="scss" scoped>
.drawer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.drawer-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}
.parent-card {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  margin-bottom: 12px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #ebeef5;
  transition: all 0.3s;
  animation: fadeInUp 0.4s ease both;
}
.parent-card:hover {
  border-color: #409EFF;
  box-shadow: 0 2px 12px rgba(64, 158, 255, 0.15);
}
.card-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: linear-gradient(135deg, #409EFF, #66B1FF);
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 14px;
}
.card-info {
  flex: 1;
  min-width: 0;
}
.card-name {
  font-size: 15px;
  font-weight: 500;
  color: #303133;
  margin-bottom: 4px;
}
.card-meta {
  font-size: 13px;
  color: #606266;
  margin-bottom: 2px;
  i { margin-right: 2px; }
}
.card-time {
  font-size: 12px;
  color: #909399;
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
